import { Popover } from "@mui/material";
import React, { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import {
  Threedots,
  SettingsMasterCard,
  Visa,
  ThreeBlackDots,
  TrashIconGray,
  SetAsDefaultIcon,
  BankImg,
} from "../../constant/imagePath";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import classes from "./paymentMethodCard.module.css";

function CustomPopover({ handleClose, anchorEl, onRemove, onDefault }) {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <div className={[classes.overlayBox]}>
        <div
          onClick={() => {
            handleClose();
            onDefault();
          }}
        >
          <ReactSVG
            src={SetAsDefaultIcon}
            beforeInjection={(svg) => svg.classList.add(classes.icon)}
          />
          <span style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
            Set as Default
          </span>
        </div>
        <div
          onClick={() => {
            handleClose();
            onRemove();
          }}
        >
          <ReactSVG
            src={TrashIconGray}
            beforeInjection={(svg) => svg.classList.add(classes.icon)}
          />
          <span style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
            Remove
          </span>
        </div>
      </div>
    </Popover>
  );
}

function PaymentMethodCard({ data, onRemove, onDefault, isDone }) {
  const decideImg = (type) => {
    return (type == "master" && SettingsMasterCard) || (type == "visa" && Visa);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {data?.methodType == 'bank' ?
        <div
          className={[classes.card].join(" ")}
          style={{
            height: `${data?.default ? "76px" : data?.time && data?.date ? "79px" : "72px"
              }`,
          }}

        >
          <div className={[classes.leftBox].join(" ")}>
            <img
              src={BankImg}
              className={[classes.mr26, classes.cardimg].join(" ")}
              alt="..."
            />
            <div>
              <p
                style={{
                  ...Fonts.p2,
                  color: Colors.neutralShadesOfNero,
                }}
                className={[classes.mb4].join(" ")}
              >
                <span style={{ ...Fonts.h9 }}>Bank account</span> via <span style={{ ...Fonts.h9 }}>Stripe</span>
              </p>
              <p
                style={{
                  ...Fonts.p2,
                  color: Colors.neutralShadesOfNero,
                  lineHeight: "20px",
                }}
              >
                {'100000 '}&#x2022;&#x2022;&#x2022;&#x2022;{" "}{data?.number}
              </p>
            </div>
          </div>
          <div>
            {isDone ? (
              <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                ${data?.amount}
              </h5>
            ) : (
              <>
                <ReactSVG src={ThreeBlackDots} onClick={handleClick} className={classes.dotsIcon} />
                <CustomPopover
                  handleClose={handleClose}
                  anchorEl={anchorEl}
                  onRemove={onRemove}
                  onDefault={onDefault}
                />
              </>
            )}
          </div>
        </div>
        : <div
          className={[classes.card].join(" ")}
          style={{
            height: `${data?.default ? "76px" : data?.time && data?.date ? "79px" : "72px"
              }`,
          }}
        >
          <div className={[classes.leftBox].join(" ")}>
            <img
              src={decideImg(data?.type)}
              className={[classes.mr26, classes.cardimg].join(" ")}
              alt="..."
            />
            <div>
              <p
                style={{
                  ...Fonts.p2,
                  color: Colors.neutralShadesOfNero,
                }}
                className={[classes.mb4].join(" ")}
              >
                {data?.title} {data?.number}
              </p>
              {data?.date && data?.time && (
                <div className={classes.dateAndTime}>
                  <span
                    style={{
                      ...Fonts.b2,
                      lineHeight: "20px",
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    {data?.date}
                  </span>
                  <span
                    className={classes.dot}
                    style={{
                      backgroundColor: Colors.neutralShadesOfDimGray,
                    }}
                  />
                  <span
                    style={{
                      ...Fonts.b2,
                      lineHeight: "20px",
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    {data?.time}
                  </span>
                </div>
              )}
              <p
                style={{
                  ...Fonts.b2,
                  color: Colors.neutralShadesOfDimGray,
                  lineHeight: "20px",
                }}
              >
                {data?.default && "This is your default payment method"}
              </p>
            </div>
          </div>
          <div>
            {/*  */}
            {isDone ? (
              <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                ${data?.amount}
              </h5>
            ) : (
              <>
                <ReactSVG src={ThreeBlackDots} onClick={handleClick}
                  className={classes.dotsIcon}
                />
                <CustomPopover
                  handleClose={handleClose}
                  anchorEl={anchorEl}
                  onRemove={onRemove}
                  onDefault={onDefault}
                />
              </>
            )}

            {/*  */}
          </div>
        </div>}
    </>
  );
}

export default PaymentMethodCard;
